import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        badge: {
            border: `2px solid ${theme.palette.grey[200]}`,
        },
    })
);
